import TopLayout from "@/Components/templates/TopLayout";
import { Link } from "@inertiajs/react";

export default function Top() {
  return (
    <TopLayout pageTitle="サイトトップ">
      <section>
        <div className="container mx-auto flex px-5 py-8 md:flex-row flex-col items-center justify-center">
          <div className="flex flex-col items-center text-center">
            <h1 className="sm:text-5xl text-2xl mb-4 font-medium">
              国政を、データで検証する。
            </h1>
            <div className="mb-4 flex items-center text-slate-200 sm:text-lg text-sm">
              <div className="mr-1">－</div>
              <h2 className="leading-relaxed">
                国政状況データ計算可視化システム
              </h2>
              <div className="ml-1">－</div>
            </div>
            <div>
              {/*
                主要導線はボタンではなく a で描画する。button + location.href では
                クローラがリンクとして辿れず、内部リンクとして評価されないため。
              */}
              <div className="text-center pb-4">
                <a
                  href={route("overall_overview")}
                  className="font-bold w-full h-14 inline-flex items-center justify-center text-white text-sm bg-gradient-to-l from-cyan-500 to-blue-500 rounded py-2 px-4 hover:brightness-110 hover:shadow-md hover:shadow-cyan-500/30"
                >
                  全体概要を表示
                </a>
              </div>

              {/* 塗りは「全体概要を表示」の 1 つだけ。残りの導線は線にして階層を付ける */}
              <div className="flex justify-center mb-4 font-bold">
                <a
                  href={route("human_list")}
                  className="h-12 text-sm mr-4 inline-flex items-center top-outline-button py-2 px-5 rounded mt-4 md:mt-0"
                >
                  国会議員検索
                </a>

                <a
                  href={route("political_party_list")}
                  className="h-12 text-sm inline-flex items-center top-outline-button py-2 px-5 rounded mt-4 md:mt-0"
                >
                  国政政党一覧
                </a>
              </div>
            </div>
            {/* h1 はページ主題（上のキャッチコピー）に 1 つだけ当てるため、ここは p にする */}
            <p className="font-bold text-md text-yellow-300">
              <Link
                href={route("candidate_list_syugiin_2026")}
                className={`underline decoration-yellow-300 hover:opacity-80`}
              >
                2026年衆議院議員選挙立候補者一覧及び結果
              </Link>
            </p>
          </div>
        </div>
      </section>
    </TopLayout>
  );
}
